<div class="border-1px border-base radius-lg margin-top-6 tablet:margin-top-5 desktop:margin-top-5">
  <div class="padding-3 line-height-serif-4">
    <h2 class="font-heading-md tablet:font-heading-lg line-height-sans-4 text-semibold margin-top-0 margin-bottom-105">Resources</h2>
    <hdw-resource-content-items></hdw-resource-content-items>
  </div>
</div>